import React from "react";
import { formatDisplayName } from "../../../shared/helpers";

const ErrorPopUp = ({ setError }) => {
    const handleClick = () => {
        setError(false);
    };

    return(
        <aside className='error-pop-up flex'>
            <p>No se puede eliminar esta actividad, ya que tiene solicitudes asociadas.</p>
            <button type='button' className='button-box' onClick={handleClick}><p>Ok</p></button>
        </aside>
    )
};

export const ErrorEditPopUp = ({ setError }) => {
    const handleClick = () => {
        setError(false);
    };

    return(
        <aside className='error-pop-up flex'>
            <p>No se puede editar esta actividad, ya que tiene solicitudes asociadas.</p>
            <button type='button' className='button-box' onClick={handleClick}><p>Ok</p></button>
        </aside>
    )
};

export const DeleteConfirmationPopUp = ({ onConfirm, onCancel, activityName }) => {
    return(
        <aside className='popup-container flex'>
            <h3>Confirmar eliminación</h3>
            <p>¿Está seguro que desea eliminar la actividad: <strong>{activityName ? formatDisplayName(activityName) : ''}</strong>?</p>
            <span className='popup-buttons flex'>
                <button className='button flex' onClick={onConfirm}><p>Eliminar</p></button>
                <button className='button flex' onClick={onCancel}><p>Cancelar</p></button>
            </span>
        </aside>
    )
};

export default ErrorPopUp;